import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-speed-test',
  templateUrl: './speed-test.component.html',
  styleUrls: ['./speed-test.component.css']
})
export class SpeedTestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
